import React from "react";
import PropTypes from "prop-types";
import Filter from "../../../../models/Filter";
import HoverTooltip from "../../../../components/atoms/Tooltip/HoverTooltip";
import CheckboxFilter from "./FilterTypes/CheckboxFilter";
import NumberFilter from "./FilterTypes/NumberFilter";
import ToggleFilter from "./FilterTypes/ToggleFilter";
import SelectFilter from "./FilterTypes/SelectFilter";

function FilterComponent({ ...props }) {
  const { filter } = props;
  const { type, totalCount, isVisible } = filter || {};

  function getComp() {
    if (type === "checkbox") return <CheckboxFilter {...props} />;
    if (type === "number") return <NumberFilter {...props} />;
    if (type === "toggle") return <ToggleFilter {...props} />;
    if (type === "select") return <SelectFilter {...props} />;
    return null;
  }

  return filter && (totalCount > 0 || isVisible) ? (
    <div className="tw-flex tw-items-center tw-flex-grow">
      {getComp()}

      {filter.helpTextAnchor ? <div>{filter.helpTextAnchor}</div> : null}

      {filter.helpText ? (
        <div className="tw-mx-2">
          <HoverTooltip
            ContentRenderer={() => (
              <div className="tw-max-w-md">{filter.helpText}</div>
            )}
            className="genome-browser-small-tooltip"
          >
            <i className="fa fa-question-circle" />
          </HoverTooltip>
        </div>
      ) : null}
      <div className="tw-flex-grow" />
      {totalCount !== null && type === "checkbox" ? (
        <div
          data-tooltip="total amount of items available in the graph"
          data-tooltip-class="genome-browser-small-tooltip"
          className="tw-opacity-70 tw-px-2 tw-text-2xs"
        >
          {totalCount.toLocaleString()}
        </div>
      ) : null}
    </div>
  ) : null;
}

FilterComponent.propTypes = {
  filter: PropTypes.instanceOf(Filter),
};

FilterComponent.defaultProps = {
  filter: null,
};

export default FilterComponent;
